const STORAGE_KEY = 'gp_operator_currency';

let memoryCache: string | null | undefined;
const listeners = new Set<() => void>();

function readStorage(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const v = window.sessionStorage.getItem(STORAGE_KEY);
    return v && v.length > 0 ? v : null;
  } catch {
    return null;
  }
}

function writeStorage(code: string | null): void {
  if (typeof window === 'undefined') return;
  try {
    if (code === null) window.sessionStorage.removeItem(STORAGE_KEY);
    else window.sessionStorage.setItem(STORAGE_KEY, code);
  } catch {
    // sessionStorage disabled — keep memory cache only
  }
}

function notify(): void {
  for (const cb of listeners) cb();
}

export function loadOperatorCurrency(): string | null {
  if (memoryCache !== undefined) return memoryCache;
  memoryCache = readStorage();
  return memoryCache;
}

export function saveOperatorCurrency(code: string | null | undefined): void {
  if (typeof code !== 'string' || code.length === 0) return;
  if (memoryCache === undefined) memoryCache = readStorage();
  if (memoryCache === code) return;
  memoryCache = code;
  writeStorage(code);
  notify();
}

export function clearOperatorCurrency(): void {
  if (memoryCache === undefined) memoryCache = readStorage();
  if (memoryCache === null) return;
  memoryCache = null;
  writeStorage(null);
  notify();
}

export function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
